import { combineReducers, Reducer } from 'redux';

import * as types from './meetings-simple.types';
import * as constants from './meetings-simple.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IMeetingsSimplePageState = {
  meetingsSimpleIds: [],
  accountIds: [],
  teamIds: [],
  nextMeeting: '',
  startedMeetings: [],
  filteredMeetings: [],
  liveMeetings: [],
  isFetched: false,
  isUpdateMeetingComplete: false,
};

const meetingsSimpleReducer: Reducer<
  types.IMeetingsSimplePageState['meetingsSimpleIds'],
  types.IStoreMeetingSimple | types.IClearMeetingSimple
> = (state = initialState.meetingsSimpleIds, action) => {
  if (isActionOfType<types.IStoreMeetingSimple>(action, constants.STORE_MEETING_SIMPLE)) {
    return action.payload;
  } else if (isActionOfType<types.IClearMeetingSimple>(action, constants.CLEAR_MEETING_SIMPLE)) {
    return initialState.meetingsSimpleIds;
  }

  return state;
};
const accountReducer: Reducer<
  types.IMeetingsSimplePageState['accountIds'],
  types.IStoreMeetingSimple | types.IClearMeetingSimple
> = (state = initialState.accountIds, action) => {
  if (isActionOfType<types.IStoreMeetingSimple>(action, constants.STORE_ACCOUNTS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearMeetingSimple>(action, constants.CLEAR_ACCOUNTS)) {
    return initialState.accountIds;
  }

  return state;
};
const teamReducer: Reducer<
  types.IMeetingsSimplePageState['teamIds'],
  types.IStoreMeetingSimple | types.IClearMeetingSimple
> = (state = initialState.teamIds, action) => {
  if (isActionOfType<types.IStoreMeetingSimple>(action, constants.STORE_TEAMS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearMeetingSimple>(action, constants.CLEAR_TEAMS)) {
    return initialState.teamIds;
  }

  return state;
};

const nextMeetingReducer: Reducer<
  types.IMeetingsSimplePageState['nextMeeting'],
  types.IStoreNextMeeting | types.IClearNextMeeting
> = (state = initialState.nextMeeting, action) => {
  if (isActionOfType<types.IStoreNextMeeting>(action, constants.STORE_NEXT_MEETING)) {
    return action.payload;
  } else if (isActionOfType<types.IClearNextMeeting>(action, constants.CLEAR_NEXT_MEETING)) {
    return initialState.nextMeeting;
  }
  return state;
};

const startedMeetingsReducer: Reducer<
  types.IMeetingsSimplePageState['startedMeetings'],
  types.IStoreStartedMeetings | types.IClearStartedMeetings
> = (state = initialState.startedMeetings, action) => {
  if (isActionOfType<types.IStoreStartedMeetings>(action, constants.STORE_STARTED_MEETINGS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearStartedMeetings>(action, constants.CLEAR_STARTED_MEETINGS)) {
    return initialState.startedMeetings;
  }
  return state;
};

const filteredMeetingsReducer: Reducer<
  types.IMeetingsSimplePageState['filteredMeetings'],
  types.IStoreFilteredMeetings | types.IClearFilteredMeetings
> = (state = initialState.filteredMeetings, action) => {
  if (isActionOfType<types.IStoreFilteredMeetings>(action, constants.STORE_FILTERED_MEETINGS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearFilteredMeetings>(action, constants.CLEAR_FILTERED_MEETINGS)) {
    return initialState.filteredMeetings;
  }
  return state;
};

const liveMeetingsReducer: Reducer<
  types.IMeetingsSimplePageState['liveMeetings'],
  types.ISaveLiveMeetings | types.IClearStartedMeetings
> = (state = initialState.liveMeetings, action) => {
  if (isActionOfType<types.ISaveLiveMeetings>(action, constants.SAVE_LIVE_MEETINGS)) {
    return action.payload;
  }
  return state;
};

const isFetchedReducer: Reducer<
  types.IMeetingsSimplePageState['isFetched'],
  types.IStoreIsFetched | types.IClearIsFetched
> = (state = initialState.isFetched, action) => {
  if (isActionOfType<types.IStoreIsFetched>(action, constants.STORE_IS_FETCHED)) {
    return true;
  } else if (isActionOfType<types.IClearIsFetched>(action, constants.CLEAR_IS_FETCHED)) {
    return initialState.isFetched;
  }
  return state;
};

const isUpdateMeetingCompleteReducer: Reducer<
  types.IMeetingsSimplePageState['isUpdateMeetingComplete'],
  types.IUpdateMeetingSimpleComplete | types.IClearUpdateMeetingSimpleComplete
> = (state = initialState.isUpdateMeetingComplete, action) => {
  if (isActionOfType<types.IUpdateMeetingSimpleComplete>(action, constants.UPDATE_MEETING_SIMPLE_COMPLETE)) {
    return true;
  } else if (
    isActionOfType<types.IClearUpdateMeetingSimpleComplete>(action, constants.CLEAR_UPDATE_MEETING_SIMPLE_COMPLETE)
  ) {
    return false;
  }
  return state;
};

export const meetingsSimplePageReducer: Reducer<
  types.IMeetingsSimplePageState,
  types.IMeetingsSimplePageAction
> = combineReducers({
  meetingsSimpleIds: meetingsSimpleReducer,
  accountIds: accountReducer,
  teamIds: teamReducer,
  nextMeeting: nextMeetingReducer,
  startedMeetings: startedMeetingsReducer,
  filteredMeetings: filteredMeetingsReducer,
  liveMeetings: liveMeetingsReducer,
  isFetched: isFetchedReducer,
  isUpdateMeetingComplete: isUpdateMeetingCompleteReducer,
});
